import { CompetenciesImporterPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const CompetenciesImporterPage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()

  const { data, loading, error } = useQuery(CompetenciesImporterPageDocument, {
    variables: { companyId: company.id },
    fetchPolicy: 'network-only',
  })

  const isLegacyJobCatalogEnabled =
    data?.features.featuresConnection.nodes.find(
      (featureFlag) => featureFlag.name === 'legacy_job_catalog'
    )?.enabled ?? false
  const isJobCatalogTreeEnabled = !isLegacyJobCatalogEnabled

  const canManageCompetencies = data?.competencies?._policies?.competenciesManage?.can ?? false
  const canImportResources = data?.universalImporter._policies.importResources.can

  return (
    <ResponsivePage.Body
      authorized={isJobCatalogTreeEnabled && canManageCompetencies && canImportResources}
      loading={loading}
      error={error}
    >
      <NuvoImporter
        importType="competencies_competency_importer"
        locale={locale}
        companyId={company.id}
      />
    </ResponsivePage.Body>
  )
}

export default CompetenciesImporterPage
